module.exports = __webpack_public_path__ + "img/aston-martin.e35ef7f5.webp";